const $ = require("jquery");

$(".js-eu-cookie-compliance-category-descriptions-trigger").each(function() {
  const $wrapper = $(".js-eu-cookie-compliance-category-descriptions-wrapper")

  $(this).on("click", function(event) {
    event.preventDefault();
    $wrapper.toggleClass("is-active");
  });
});